var WDN = WDN || {};

if (typeof WDN.CollectionStockOverview === "undefined") {
  WDN.CollectionStockOverview = (function () {
    class CollectionStockOverview extends HTMLElement {
      constructor() {
        super();
      }

      init() {
        let url = Shopify.routes.root + "collections/" + this.collectionHandle + "?section_id=async-collection-stock";
        fetch(url)
          .then((res) => {
            return res.text();
          })
          .then((resText) => {
            let parser = new DOMParser();
            let parsedResponse = parser.parseFromString(resText, "text/html");
            let parsedJSONResponse = JSON.parse(parsedResponse.querySelector("script").innerText);

            // Remove loading
            this.soldoutCountContainer.classList.remove("loading-block");
            this.totalCountContainer.classList.remove("loading-block");

            if(parsedJSONResponse.soldoutCount == 0) {
              this.remove();
              return;
            }

            // Inject
            this.soldoutCountContainer.innerHTML = parsedJSONResponse.soldoutCount;
            this.totalCountContainer.innerHTML = parsedJSONResponse.totalCount;
          })
          .catch((err) => {
            this.innerHTML = "";
          });
      }

      connectedCallback() {
        // Nodes
        this.soldoutCountContainer = this.querySelector("[data-collection-count='sold_out']");
        this.totalCountContainer = this.querySelector("[data-collection-count='total']");

        //  Collection handle
        this.collectionHandle = this.getAttribute("data-collection");

        // Start
        this.init();
      }
    }

    customElements.define("collection-stock-overview", CollectionStockOverview);
    return CollectionStockOverview;
  })();
}
